export const CHANGE_FORM = 'CHANGE_FORM'

export function forms(forms={}, action) {
  switch(action.type) {
    case CHANGE_FORM:
      return {
        ...forms,
        [action.form]: action.data
      }
    default:
      return forms
  }
}